import React from 'react'
import injectSheet from 'react-jss'
import SEARCH_ICON from 'public/assets/svg/icons/icon_search.svg'
import CLOSE_ICON from 'public/assets/svg/close-button.svg'
import SearchResults from '../containers/SearchResults'

const styleSheet = {
    container: {
        position: 'absolute',
        left: '0',
        top: '0',
        right: '0',
        bottom: '0',
        zIndex: 10000,
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: ({ isDeviceMobile }) => (isDeviceMobile ? '' : 'center'),
        // need pseudo-selector for chrome workaround with backdropFilter
        '&:before': {
            content: '""',
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            zIndex: ' -1',
            backgroundColor: 'rgb(13 20 35 / 72%)',
            backdropFilter: 'blur(5px)',
            '-webkit-backdrop-filter': 'blur(5px)',
        },
    },
    inputContainer: {
        position: 'relative',
        width: ({ isDeviceMobile }) => (isDeviceMobile ? '90%' : '640px'),
        marginLeft: ({ isDeviceMobile }) => (isDeviceMobile ? '20px' : ''),
        marginTop: ({ isDeviceMobile }) => (isDeviceMobile ? '35px' : '100px'),
    },
    searchBar: {
        background: 'white',
        height: ({ isDeviceMobile }) => (isDeviceMobile ? '40px' : '50px'),
        width: ({ isDeviceMobile }) => (isDeviceMobile ? '62%' : '100%'),
        padding: ({ isDeviceMobile }) => (isDeviceMobile ? '0 36px 0 36px' : '0 50px 0 50px'),
        fontFamily: `CircularStd, Circular Std Book`,
        border: '1px solid rgba(99, 115, 164, 0.2)',
        borderRadius: '5px',
        fontSize: ({ isDeviceMobile }) => (isDeviceMobile ? '14px' : '18px'),
        lineHeight: '24px',
        '&::placeholder': {
            color: 'rgba(99, 115, 164, 1)',
        },
        '&:focus': {
            outline: 'none',
        },
    },
    searchIcon: {
        position: 'absolute',
        top: '58%',
        left: ({ isDeviceMobile }) => (isDeviceMobile ? '5px' : '10px'),
        transform: ({ isDeviceMobile }) =>
            isDeviceMobile ? 'translateY(-52%) scale(0.68)' : 'translateY(-50%) scale(0.85)',
        filter: 'invert(53%) sepia(6%) saturate(2488%) hue-rotate(188deg) brightness(83%) contrast(93%)',
        cursor: 'pointer',
    },
    closeIcon: {
        position: 'absolute',
        top: '51%',
        left: ({ isDeviceMobile }) => (isDeviceMobile ? '75%' : ''),
        right: ({ isDeviceMobile }) => (isDeviceMobile ? '' : '-80px'),
        transform: ({ isDeviceMobile }) => (isDeviceMobile ? 'translateY(-50%)' : 'translateY(-50%) scale(1.2)'),
        filter: 'invert(53%) sepia(6%) saturate(2488%) hue-rotate(188deg) brightness(83%) contrast(93%)',
        cursor: 'pointer',
    },
    cancel: {
        color: 'rgba(255, 255, 255, 1)',
        fontFamily: `CircularStd, Circular Std Book`,
        fontSize: '12px',
        lineHeight: '24px',
        fontWeight: 450,
        marginLeft: '12px',
    },
}

const SearchAIPrompt = ({
    showSearchAIPrompt,
    searchInputValue,
    onClick,
    onChange,
    onInputClick,
    onSearchClick,
    onClearClick,
    onKeyPress,
    classes,
    isDeviceMobile,
    showResults,
    results,
}) => {
    return (
        showSearchAIPrompt && (
            <div className={classes.container} onClick={onClick}>
                <div className={classes.inputContainer}>
                    <img className={classes.searchIcon} src={SEARCH_ICON} onClick={onSearchClick} />
                    <input
                        className={classes.searchBar}
                        value={searchInputValue}
                        onChange={onChange}
                        onClick={onInputClick}
                        onKeyPress={onKeyPress}
                        placeholder="What would you like to see?"
                    />
                    {searchInputValue.length > 0 && (
                        <img className={classes.closeIcon} src={CLOSE_ICON} onClick={onClearClick} />
                    )}
                    {isDeviceMobile && (
                        <span onClick={onClick} className={classes.cancel}>
                            Cancel
                        </span>
                    )}
                </div>
                {showResults && <SearchResults results={results} isDeviceMobile={isDeviceMobile} />}
            </div>
        )
    )
}

export default injectSheet(styleSheet)(SearchAIPrompt)
